/*
    Тип Аппаратных модулей
*/
export enum HardwareDataType {
  SVM = 1,
  WVS = 2,
}
